/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EmployeePostViewModelPaginatedResponse } from "../types/EmployeePostViewModelPaginatedResponse.ts";
import { employeePostViewModelSchema } from "./employeePostViewModelSchema.ts";

export const employeePostViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => employeePostViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<EmployeePostViewModelPaginatedResponse>;
